import { Helmet } from "react-helmet-async";
import React from "react";
import {
  Container,
  createStyles,
  Text,
  List,
  AspectRatio,
  Group,
  Button,
} from "@mantine/core";
import { PageTitle } from "../../shared/ui/PageTitle";
import { wrapUrlWithCurrentQuery } from "common";

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  container: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },
}));

// ----------------------------------------------------------------------

export function AffiliateProgramPage(): React.JSX.Element {
  const { classes } = useStyles();
  const url = new URL(window.location.href);

  return (
    <>
      <Helmet>
        <title>Партнерская программа учебного центра BODY COACH</title>
        <meta
          property="og:title"
          content="Партнерская программа учебного центра Body Coach"
        />

        <meta
          name="description"
          content="Партнерская программа учебного центра BODY COACH позволяет нашим студентам стать нашими
          партнерами и начать зарабатывать на продаже обучающих курсов."
        />
        <meta
          property="og:description"
          content="Партнерская программа учебного центра BODY COACH позволяет нашим студентам стать нашими
          партнерами и начать зарабатывать на продаже обучающих курсов."
        />

        <meta property="og:url" content={url.href} />
        <link rel="canonical" href={url.href} />
        <meta property="og:site_name" content={url.host} />
        <meta name="robots" content="index, follow" />

        <meta
          name="keywords"
          content="партнерская программа боди коуч, партнерка боди коуч, партнерская программа body coach, заработок на курсах боди коуч"
        />
      </Helmet>

      <Container size="lg" className={classes.container}>
        <PageTitle title="Партнерская программа BODY COACH" />

        <Text fw={700} mb="xl">
          Партнерская программа учебного центра BODY COACH позволяет нашим
          студентам стать нашими партнерами и начать зарабатывать на продаже
          обучающих курсов.
        </Text>

        <Text mb="xl">Как работает партнерская программа?</Text>

        <List type="ordered" mb="xl" spacing="md" pr="xl">
          <List.Item>
            Вы регистрируетесь в партнерской программе и получаете доступ к
            кабинету партнера.
          </List.Item>
          <List.Item>
            В разделе{" "}
            <Text span fw={700}>
              &#34;партнерские ссылки&#34;
            </Text>{" "}
            у каждого партнера имеются{" "}
            <Text span fw={700}>
              ИНДИДВИДУАЛЬНЫЕ
            </Text>{" "}
            ссылки на приобретение курсов учебного центра.
          </List.Item>
          <List.Item>
            Если новый студент перейдет по вашей ссылке и купит обучение, то вы
            получаете{" "}
            <Text span fw={700}>
              20%
            </Text>{" "}
            вознаграждения от стоимости обучения за маленькие курсы и наборы и{" "}
            <Text span fw={700}>
              10%
            </Text>{" "}
            за профессии.
          </List.Item>
          <List.Item>
            Партнерские вознаграждения выплачиваются каждое 10 число месяца
            следующего месяца.
          </List.Item>
        </List>

        <Text mb={48}>
          Присоединяйтесь к команде учебного центра BODY COACH и зарабатывайте
          на своем любимом деле!
        </Text>

        <AspectRatio ratio={16 / 9} maw={768} mx="auto">
          <iframe
            src="https://www.youtube.com/embed/sE3fXYs_9e8"
            title="Как работает партнерская программа"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </AspectRatio>

        <Group position="center" mt={48} spacing="xl">
          <Button
            radius="md"
            size="lg"
            color="orange"
            component="a"
            href={wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/aff/reg")}
            target="_blank"
          >
            Стать партнером
          </Button>
          <Button
            radius="md"
            size="lg"
            component="a"
            href={wrapUrlWithCurrentQuery("https://academy.bodycoach.pro/login")}
            target="_blank"
          >
            Войти в личный кабинет
          </Button>
        </Group>
      </Container>
    </>
  );
}
